// src/app/redux/reducers/workflowReducer.js

import {
    FETCH_WORKFLOWS_REQUEST,
    FETCH_WORKFLOWS_SUCCESS,
    FETCH_WORKFLOWS_FAIL,
    SAVE_WORKFLOW_REQUEST,
    SAVE_WORKFLOW_SUCCESS,
    SAVE_WORKFLOW_FAIL,
    DELETE_WORKFLOW_REQUEST,
    DELETE_WORKFLOW_SUCCESS,
    DELETE_WORKFLOW_FAIL,
} from '../actions/workflowActions';

const initialState = {
    list: [],
    loading: false,
    error: null,
};

const workflowReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_WORKFLOWS_REQUEST:
        case SAVE_WORKFLOW_REQUEST:
        case DELETE_WORKFLOW_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case FETCH_WORKFLOWS_SUCCESS:
            return {
                ...state,
                list: action.payload,
                loading: false,
            };

        case SAVE_WORKFLOW_SUCCESS:
            const exists = state.list.find(w => w.id === action.payload.id);
            return {
                ...state,
                list: exists 
                    ? state.list.map(w => w.id === action.payload.id ? action.payload : w)
                    : [...state.list, action.payload],
                loading: false,
            };

        case DELETE_WORKFLOW_SUCCESS:
            return {
                ...state,
                list: state.list.filter(w => w.id !== action.payload),
                loading: false,
            };

        case FETCH_WORKFLOWS_FAIL:
        case SAVE_WORKFLOW_FAIL:
        case DELETE_WORKFLOW_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};

export default workflowReducer;
